<div class="site-search">
    <div>
        <input
            class="mat-text-field"
            [id]="insightSearch ? 'insight-search-input' : 'site-search-input'"
            #siteSearchInput
            type="text"
            placeholder="Search"
            [formControl]="inputTerm"
            aria-hidden="true"
            (focus)="openMenu()"
            (keyup.enter)="openDialog('Grid')"
            (keyup.esc)="closeInput()"
        />
        <mat-icon
            tabindex="0"
            class="site-search-searching-icon"
            fontSet="fa"
            fontIcon="fa-search"
            aria-hidden="true"
            *ngIf="!searchActive"
            (click)="insightSearch ? openMenu() : openInput()"
            [ngClass]="insightSearch ? 'insight-search-searching-icon' : ''"
        ></mat-icon>
        <mat-icon
            tabindex="0"
            class="site-search-times-icon"
            fontSet="fa"
            fontIcon="fa-times"
            aria-hidden="true"
            *ngIf="searchActive"
            (click)="closeInput()"
        ></mat-icon>
        <spin-loader
            *ngIf="loading"
            [type]="'spinner'"
            class="search-spinner-override"
            [ngStyle]="{ right: insightSearch ? '27px' : '0' }"
        ></spin-loader>
    </div>
    <div
        class="site-search-dialog-container site-search-results"
        [ngClass]="insightSearch ? 'insight-search-results' : ''"
    >
        <div
            class="site-search-dialog-area"
            *ngIf="isSiteSearchDialogOpen"
            [ngStyle]="{ right: insightSearch ? '11px' : '0' }"
        >
            <mat-card class="filter-option-card lg-scrollbar">
                <div class="no-data-message-area" *ngIf="noResults">
                    <no-data-screen [noDataType]="noDataType"> </no-data-screen>
                </div>
                <div class="list-group-area">
                    <div *ngIf="loans.length > 0">
                        <div class="list-group-header" *ngIf="!insightSearch">Loans</div>
                        <mat-list>
                            <mat-list-item class="list-item" *ngFor="let result of loans">
                                <span
                                    class="mat-list-item__text"
                                    (click)="openModal(result.identifier)"
                                >
                                    {{ result.name }} - {{ result.identifier }}
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <div *ngIf="employees.length > 0">
                        <div class="list-group-header">Employees</div>
                        <mat-list>
                            <mat-list-item
                                *ngFor="let result of employees"
                                tabindex="0"
                                class="list-item"
                            >
                                <span
                                    class="mat-list-item__text"
                                    (click)="openEmployee(result.identifier)"
                                >
                                    {{ result.name }} - {{ result.description }}
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </div>
                    <div *ngIf="entities.length > 0">
                        <div class="list-group-header">Entities</div>
                        <mat-list>
                            <mat-list-item
                                *ngFor="let result of entities"
                                class="list-item"
                                tabindex="0"
                            >
                                <span
                                    class="mat-list-item__text"
                                    (click)="openEntity(result.identifier)"
                                >
                                    {{ result.name }} - {{ result.description }}
                                </span>
                            </mat-list-item>
                        </mat-list>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>
</div>
